import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot, CanActivate, CanActivateChild } from '@angular/router';
import { Observable } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';
import { UserService } from './user.service';
@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate, CanActivateChild {

  constructor(
    private router: Router,
    private cookieService: CookieService,
    public user: UserService
    ) { }
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot):
    boolean | Observable<boolean> | Promise<boolean> {
    if (this.cookieService.get('X-Auth')) {
      // logged in so return true
      return true;
    }

    // captture the url requested for sso redirect
    const attemptedUrl = state.url;

    // not logged in so redirect to home page with the return url
    this.router.navigate(['/home'], {
      queryParams: { returnUrl: attemptedUrl }
    }).then(() => {
      sessionStorage.removeItem('user');
      this.cookieService.deleteAll('/');
      sessionStorage.clear();
      this.user.init();
      window.location.reload();
    });
    return false;
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot):
    boolean | Observable<boolean> | Promise<boolean> {
    return this.canActivate(route, state);
  }
}
